import React from 'react';
import { observer } from 'mobx-react';

import { useStore } from 'core/store/';
import { Discount } from '../discount';

const FarmAssociationDiscount = observer(({ isActive, ...discount }) => {
  const { offer: store } = useStore();
  const { setShowFarmAssociationModal, showFarmAssociationModal, includeAssociationDiscount } = store;

  const onAddClick = () => {
    setShowFarmAssociationModal(true);
  };

  const farmAssociationInfo = { includeAssociationDiscount, showFarmAssociationModal };

  return (
    <Discount {...discount} isActive={isActive} onAdd={onAddClick} canEdit farmAssociationInfo={farmAssociationInfo} />
  );
});

export default FarmAssociationDiscount;
